import { render, staticRenderFns } from "./DyzHcfx.vue?vue&type=template&id=2c8c431c&scoped=true&"
import script from "./DyzHcfx.vue?vue&type=script&lang=js&"
export * from "./DyzHcfx.vue?vue&type=script&lang=js&"
import style0 from "./DyzHcfx.vue?vue&type=style&index=0&id=2c8c431c&lang=less&scoped=true&"
import style1 from "./DyzHcfx.vue?vue&type=style&index=1&id=2c8c431c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c431c",
  null
  
)

export default component.exports